import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import { MoonLoader } from 'react-spinners';
import MatchSliderCard from './MatchSliderCard/MatchSliderCard';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useSliderMatches } from '../../../../hooks/matchHooks/useMatchData';
import './MatchSlider.css';

export default function MatchSlider() {
  const { data: sliderMatches, isLoading, startingCardIndex } = useSliderMatches();

  const sliderRef = useRef(null);

  const [settings, setSettings] = useState({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    initialSlide: 0,
  });

  function NextArrow(props) {
    const { onClick } = props;
    return (
      <button
        onClick={onClick}
        className="match-slider__scroll-button match-slider__scroll-button--right"
      >
        <ChevronRight size={36} />
      </button>
    );
  }

  function PrevArrow(props) {
    const { onClick } = props;
    return (
      <button
        onClick={onClick}
        className="match-slider__scroll-button match-slider__scroll-button--left"
      >
        <ChevronLeft size={36} />
      </button>
    );
  }
  
  function responsiveSettings() {
    const width = window.innerWidth;
    if (width < 480) {
      return { slidesToShow: 1, slidesToScroll: 1 };
    } else if (width < 800) {
      return { slidesToShow: 2, slidesToScroll: 1 };
    } else if (width < 1200) {
      return { slidesToShow: 3, slidesToScroll: 1 };
    } else if (width < 1500) {
      return { slidesToShow: 4, slidesToScroll: 1 };
    } else {
      return { slidesToShow: 5, slidesToScroll: 1 };
    }
  }

  // Update settings on mount and window resize
  useEffect(() => {
    const updateSettings = () => {
      setSettings(prev => ({
        ...prev,
        ...responsiveSettings()
      }));
    };

    updateSettings();
    window.addEventListener('resize', updateSettings);
    return () => window.removeEventListener('resize', updateSettings);
  }, []);

  // Go to starting card index when matches load
  useEffect(() => {
    if (!isLoading && startingCardIndex !== undefined && startingCardIndex !== null && sliderRef.current) {
      setTimeout(() => {
        sliderRef.current.slickGoTo(startingCardIndex);
      }, 100);
    }
  }, [isLoading, startingCardIndex]);
  
  if (isLoading) {
    return <MoonLoader color="#36d7b7" size={50} />;
  }

  let lastDate = null;
  return (
    <div className="slider-container">
      <Slider {...settings} ref={sliderRef}>
        {sliderMatches.map((match, index) => {
          const isFirstOfDay = match.date !== lastDate;
          lastDate = match.date;
          return <MatchSliderCard match={match} key={index} isFirstOfDay={isFirstOfDay}/>
        })}
      </Slider>
    </div>
  );
}
